import { useEffect, useRef, useState, KeyboardEvent } from "react";
import {
  Flex,
  Text,
  InputProps as ChakraInputProps,
  FormControl,
  Box,
  Image,
  Input as ChakraInput,
} from "@chakra-ui/react";
import useOutsideClick from "@/utils/outsideClick";
import { RiArrowDropDownLine } from "react-icons/ri";
import { stdnum } from 'stdnum';
import { countries as ListCountries } from "countries-list";
import { cnpj, cpf } from "@/utils";
import { ActionDrawerItem, DrawerList, Input as InputBarte } from "barte-design-system";

interface InputProps extends ChakraInputProps {
  name: string;
  label?: string;
  labelColor?: string;
  register?: any;
  defaultDocumentType?: string;
  defaultCountry?: string;
  setValue?: any;
  getValues?: any;
  errors?: any;
  mask?: string;
  isDisabled?: boolean;
  labelPlaceholder?: string;
  secondaryLabel?: string;
  fixedLabel?: string;
  borderRadius?: string;
  height?: string;
  fontSize?: string;
  optionalText?: string;
  tooltipText?: string;
  icon?: React.ReactNode;
  className?: string;
}

export function DocumentInput({
  name,
  setValue,
  getValues,
  label,
  labelColor,
  register,
  errors,
  mask,
  variant,
  color,
  isDisabled,
  defaultDocumentType = "cpf",
  defaultCountry = "BR",
  secondaryLabel,
  labelPlaceholder,
  borderRadius,
  height,
  fixedLabel,
  fontSize,
  optionalText,
  tooltipText,
  icon,
  className,
  ...rest
}: InputProps) {
  const arrayCountries = Object.keys(stdnum);
  const [selectedCountry, setSelectedCountry] = useState(defaultCountry);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isDocumentDropdownOpen, setIsDocumentDropdownOpen] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const dropdownRef = useRef(null);
  const documentDropdownRef = useRef(null);
  const inputRef = useRef(null);
  const [documentCountryList, setDocumentCountryList] = useState([]);
  const [selectedDocument, setSelectedDocument] = useState(defaultDocumentType)
  const elementRef = useRef(null);
  const filteredArrrayCountries = arrayCountries.filter(ac => ListCountries[ac]?.name?.toLocaleLowerCase()?.includes(searchValue?.toLocaleLowerCase()));
  
  useOutsideClick(dropdownRef, () => {
    if (isDropdownOpen) {
      setIsDropdownOpen(false);
    }
  });
  useOutsideClick(documentDropdownRef, () => {
    if (isDocumentDropdownOpen) {
      setIsDocumentDropdownOpen(false);
    }
  });

  const handleMaskInput = (e: KeyboardEvent<HTMLInputElement>) => {
    if (mask === "cpf") {
      cpf(e);
    } else if (mask === "cnpj") {
      cnpj(e);
    }
  };

  function handleSelectCountry(country: any) {
    setSelectedCountry(country);
    setIsDropdownOpen(false);
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }

  useEffect(() => {
    if (selectedCountry === undefined) return;
  }, [selectedCountry])


  useEffect(() => {
    const documentList = Object.keys(stdnum[selectedCountry]);
    setDocumentCountryList(documentList)
    if(selectedCountry === "BR") {
        setSelectedDocument("cpf")
    } else {
        setSelectedDocument(documentList[0])
    }
    setValue("documentNation", selectedCountry)
  }, [selectedCountry])

  useEffect(() => {
    setValue("documentType", selectedDocument);
  }, [selectedDocument])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (register?.onChange) {
      register.onChange(e);
    }
    if (rest?.onChange) {
      rest.onChange(e);
    }
  };

  return (
    <FormControl isInvalid={!!errors?.message}>
      <Flex flexDir="column">
        {fixedLabel && (
          <Text
            marginBottom=".2rem"
            fontSize=".8rem"
            color={variant === "FAST" ? "white" : "black"}
          >
            {fixedLabel}
          </Text>
        )}
        <Box position="relative" ref={elementRef}>
          <Box position="relative" display="inline-block" width="100%">
            <InputBarte
              ref={inputRef}
              onKeyUp={handleMaskInput}
              name={name}
              type="text"
              label={label}
              labelOptional={optionalText}
              helpText={tooltipText}
              error={errors?.message}
              icon={icon}
              className={className}
              disabled={isDisabled}
              onChange={handleChange}
              {...rest}
              {...(register || {})}
              style={{
                paddingLeft: "220px",
                fontSize: fontSize ? fontSize : '1.4rem',
                ...rest?.style,
              }}
            />
            <Box
              position="absolute"
              left="8px"
              top={0}
              zIndex={10}
              pointerEvents={isDisabled ? "none" : "auto"}
            >
              <button
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setIsDropdownOpen(!isDropdownOpen);
                }}
                onMouseDown={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }}
                disabled={isDisabled}
                style={{
                  cursor: isDisabled ? 'not-allowed' : 'pointer',
                  maxWidth: '100px',
                  height: "35px",
                  background: 'transparent',
                  border: 'none',
                  padding: 0
                }}
                type="button"
              >
                <Flex
                  alignItems="center"
                  gap="2"
                  px=".8rem"
                  h="100%"
                  borderRight={variant === "FAST" ? "1px solid #F89C004D" :"1px solid rgba(184, 198, 225, 1)"}
                >
                  <Image
                    w={6}
                    h={4}
                    src={`https://purecatamphetamine.github.io/country-flag-icons/3x2/${selectedCountry}.svg`}
                  />
                  <RiArrowDropDownLine size={30} />
                </Flex>
              </button>
            </Box>
            {selectedCountry && (
              <Box
                position="absolute"
                left="108px"
                top={0}
                zIndex={999}
                pointerEvents={isDisabled ? "none" : "auto"}
              >
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setIsDocumentDropdownOpen(!isDocumentDropdownOpen);
                  }}
                  onMouseDown={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                  }}
                  disabled={isDisabled}
                  style={{
                    cursor: isDisabled ? 'not-allowed' : 'pointer',
                    maxWidth: '100px',
                    height: '35px',
                    background: 'transparent',
                    border: 'none',
                    padding: 0
                  }}
                  type="button"
                >
                  <Flex
                    alignItems="center"
                    gap="2"
                    px=".8rem"
                    h="100%"
                    borderRight={variant === "FAST" ? "1px solid #F89C004D" :"1px solid rgba(184, 198, 225, 1)"}
                  >
                    <Text fontSize=".8rem">{`${selectedDocument}`.toLocaleUpperCase()}</Text>
                    <RiArrowDropDownLine size={30} />
                  </Flex>
                </button>
              </Box>
            )}
          </Box>
          {isDropdownOpen && (
            <Box
              position="absolute"
              zIndex={999}
              top="calc(100% + .4rem)"
              ref={dropdownRef}
            >
              <DrawerList>
                <Box w="320px" maxW="90vw">
                  <Box px="2" pt="2" pb="1">
                    <ChakraInput
                      size="sm"
                      borderRadius="var(--border-radius-sm)"
                      value={searchValue}
                      onChange={(e) => setSearchValue(e.target.value)}
                      placeholder="Pesquisar país"
                      isDisabled={isDisabled}
                    />
                  </Box>
                  <Box maxH="300px" overflowY="auto">
                    {filteredArrrayCountries?.map((country) => (
                      <ActionDrawerItem
                        key={ListCountries[country].name}
                        variant="icon"
                        icon={<Image w={6} h={4} src={`https://purecatamphetamine.github.io/country-flag-icons/3x2/${country}.svg`} />}
                        label={ListCountries[country].name}
                        onClick={() => handleSelectCountry(country)}
                      />
                    ))}
                  </Box>
                </Box>
              </DrawerList>
            </Box>
          )}

          {isDocumentDropdownOpen && (
            <Box
              position="absolute"
              left="108px"
              zIndex={10}
              top="calc(100% + .4rem)"
              ref={documentDropdownRef}
            >
              <DrawerList
                items={documentCountryList?.map((document) => ({
                  label: `${document}`.toLocaleUpperCase(),
                  onClick: () => {
                    setSelectedDocument(document);
                    setIsDocumentDropdownOpen(false);
                  },
                }))}
              />
            </Box>
          )}
          {secondaryLabel && (
            <Text
              fontSize=".8rem"
              color="gray.300"
              mt=".2rem"
            >
              {`${" "}${secondaryLabel}`}
            </Text>
          )}
        </Box>
      </Flex>
    </FormControl>
  );
}
